<div class="in-use-condition-block">
  <select2 (valueChanged)="onStateChange($event)" [value]="selectedState" [data]="data" [options]="selectOptions"></select2>

  <div class="duration-field">
    <span class="field-label">{{ 'SHARED.For_at_least' | translate }}</span>
    <input type="number"
           class="duration-input"
           [value]="hours"
           (input)="onHoursInput($event)"
           min="0"
           placeholder="0">
    <span class="field-label">{{ 'SHARED.Hours' | translate }}</span>
    <input type="number"
           class="duration-input"
           [value]="minutes"
           (input)="onMinutesInput($event)"
           min="0"
           max="59"
           placeholder="0">
    <span class="field-label">{{ 'SHARED.Minutes' | translate }}</span>
  </div>
</div>
